import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const PasswordSimilarAsIdError = () => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="password-similar-error" severity="error">
            {t('formErrors.passwordSimilarAsIdError.tryAgain')}
        </Alert>
    );
};
